import loadable from '@loadable/component';

export const MyAccountPage = loadable(/* #__LOADABLE__ */ () => import('./MyAccountPage'));
